exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* TYPOGRAPHY */\r\n.mark, mark {\r\n    background: #f2a654;\r\n    color: #ffffff;\r\n}\r\n\r\n.blockquote {\r\n    background: #f2f4f8;\r\n    padding: 30px;\r\n    border-left: 3px solid #d2d9e5;\r\n    font-size: 1.07rem;\r\n}\r\n\r\n.blockquote-reverse {\r\n    text-align: right;\r\n    border-left: none;\r\n    border-right: 3px solid #d2d9e5;\r\n}\r\n\r\n.blockquote-footer {\r\n    margin-top: 1.42rem;\r\n    color: #b8beca;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null],"sourceMap":false}!./src/assets/modules/vendors/bootstrap/css/typography.css
// module id = ./node_modules/css-loader/index.js?{"sourceMap":false,"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null,null],"sourceMap":false}!./src/assets/modules/vendors/bootstrap/css/typography.css
// module chunks = styles